export default __webpack_public_path__ + "static/media/LoadImg.097418ec.svg";